module.exports = __webpack_public_path__ + "media/images/countryrect/ms-53011226b5ce0e1147838f137ee96233.svg";